<template>
    <div
        class="coupon-item-wrapper"
        :class="{
            active: active,
            expand: isExpand,
            [`type-${isDoubleCard ? 'DOUBLE-CARD' : coupon.couponTarget}`]: 1,
        }"
        @click="emitItemClick('coupon')"
    >
        <div class="coupon-item-main">
            <div class="item-left">
                <div class="rate-wrapper" v-if="isDoubleCard">
                    <span class="x">x</span>
                    <span class="rate">{{ coupon.amount }}</span>
                    <span class="text">倍</span>
                </div>
                <div class="cash-back-wrapper" v-else-if="isCashBackCard">
                    <span class="text">{{ coupon.couponInfo }}</span>
                </div>
                <div class="price-wrapper" v-else-if="coupon.amount">
                    <span class="symbol">￥</span>
                    <span class="price">{{ coupon.amount | formatCouponPrice }}</span>
                </div>
                <div class="price-wrapper" v-else>
                    <span class="price">{{ coupon.discount }}</span>
                    <span class="symbol">折</span>
                </div>
                <div v-if="isDoubleCard || isCashBackCard" />
                <div v-else class="price-desc" v-html="coupon.couponInfo"></div>
                <div v-if="expiresSoon" class="expires-soon">
                    <span>快过期</span>
                </div>
            </div>
            <div class="item-right">
                <div class="text-wrapper">
                    <div class="text-wrapper-top">
                        <i
                            class="icon icon-status"
                            :class="statusIconClass"
                            v-if="useMethod !== 'check' && !disable"
                        ></i>
                        <span class="coupon-name">
                            <!-- 统一替换成省钱金卡 -->
                            <!-- <img v-if="coupon.isGoldCard" class="gold-ico" src="./images/gold-ico.png" alt="" /> -->
                            <img v-if="coupon.isGoldCard" class="gold-ico" src="./images/gold-card.png" alt="" />
                            <span v-else class="tag">{{ couponType }}</span>
                            <span class="name">{{ coupon.couponName }}</span>
                        </span>
                        <div class="middle-wrapper">
                            <div
                                class="text-middle-wrapper countdown"
                                v-if="
                                    coupon.status === 2 &&
                                        !isSellout &&
                                        countDownTime &&
                                        countDownObj &&
                                        dayLeft < coundownMaxDay
                                "
                            >
                                <div class="date-range">
                                    仅剩{{
                                        dayLeft > 0
                                            ? `${dayLeft}天`
                                            : `${countDownObj.hours}:${countDownObj.minutes}:${countDownObj.seconds}`
                                    }}
                                </div>
                            </div>
                            <div class="text-middle-wrapper" v-else>
                                <div class="date">{{ coupon.couponTimeStr ? coupon.couponTimeStr : timeRange }}</div>
                            </div>
                            <div
                                data-entrance="去使用"
                                v-if="showToUseBtn"
                                class="btn btn-use"
                                @click.stop="clickUseBtn"
                            >
                                去使用
                            </div>
                            <div
                                v-if="showReceiveBtn || showContinueBtn"
                                class="btn btn-get"
                                :class="showContinueBtn ? 'btn-continue' : ''"
                            >
                                {{ receiveBtnText }}
                            </div>
                        </div>
                        <div class="checkbox" v-if="showCheckBtn">
                            <i class="icon" :class="checked === true ? 'icon-checked' : 'icon-unchecked'"></i>
                        </div>
                    </div>
                    <div
                        class="desc-wrapper"
                        ref="descWrapper"
                        v-if="coupon.description"
                        @click.stop="expand"
                        data-role="expandEle"
                    >
                        <span>详情信息</span>
                        <i class="icon icon-arrow" :class="{ active: isExpand }"></i>
                    </div>
                </div>
            </div>
        </div>
        <div class="coupon-desc" v-if="coupon.description" v-html="coupon.description"></div>
    </div>
</template>

<script>
// todo: 根据userId和couponId缓存已领取状态(只在领取页面)
import { receiceCoupon } from 'root/coupon/api/receiveCoupon.js';
import { isValidDate, setReceiveCouponCache, receiveEmptyResult, receiveExpirationTimeRange } from './utils/index';
import loginState from 'root/common/util/getLoginState.js';
import { seckiller as countdown } from 'root/blackcard/components/mixin/seckiller';
import {
    emptyStatus,
    timeoutStatus,
    usedStatus,
    receiveStatus,
    canReceiveStatus,
    continueReceiveStatus,
    activeStatus,
    urlObjs,
    coundownMaxDay,
} from './mock/index';
import env from '@/common/util/env';

const couponTarget = {
    QSSC_GOODS: '商城券',
    QSC_TICKET: '美食购物券',
    QSC_RECHARGE: '充值券',
    CPS_TBK_GOODS: '翻倍卡',
};

export default {
    mixins: [countdown('countdownData', true)],
    props: {
        coupon: {
            require: true,
            type: Object,
        },
        useMethod: {
            default: 'click', // 可选值 1.click: 点击事件  2.check: 选择    ...
            type: String,
        },
        checked: {
            default: false,
            type: Boolean,
        },
        disable: {
            default: false,
            type: Boolean,
        },
        // 是否隐藏去使用按钮
        showGotoUseBtn: {
            default: true,
            type: Boolean,
        },
        showReceiveIcon: {
            default: true,
            type: Boolean,
        },
        // 是否默认展开
        expandDefault: {
            default: false,
            type: Boolean,
        },
        // 自定义去使用按钮 会抛出事件
        customGotoUse: {
            default: false,
            type: Boolean,
        },
        showExpiresSoon: {
            default: false,
            type: Boolean,
        },
        receiveCacheTime: {
            type: Number,
            default: receiveExpirationTimeRange,
        },

        isShowCheck: {
            type: Boolean,
            default: true,
        },
        tabLabel: {
            type: String,
            default: '',
        },
        business: {
            type: String,
            default: '',
        },
    },
    filters: {
        formatCouponPrice(num) {
            if (typeof num !== 'number') num = parseFloat(num);
            if (Number.isNaN(num)) return '';
            return num.toFixed(2);
        },
    },
    watch: {
        'coupon.couponEndTime': function() {
            this.resetTimeDown();
        },
    },
    inject: ['handleGoldSigning'],
    created() {
        if (this.expandDefault) {
            this.isExpand = true;
        }
        this.resetTimeDown();
    },
    data() {
        return {
            isExpand: false,
            continueReceiveStatus,
            coundownMaxDay,
            countdownData: {
                liveEndTime: 0,
                serverTime: 0,
            },
            isHarmoneyQskApp: env.isHarmoneyQskApp,
        };
    },
    computed: {
        // 是否可用
        active() {
            // const start = new Date(this.coupon.couponStartTime);
            // const end = new Date(this.coupon.couponEndTime);
            // if (!isValidDate(start) || !isValidDate(end)) {
            //     console.log('invalid Date');
            //     return false;
            // }
            // const now = new Date().getTime();
            // if (now < end.getTime() && now > start.getTime()) {
            //     return true;
            // }
            // return false;
            if (this.disable) {
                return false;
            }
            // 倒计时结束 变成过期样式
            if (this.isSellout) {
                return false;
            }
            return activeStatus.includes(this.coupon.status);
        },
        dayLeft() {
            if (this.countDownObj && this.countDownObj.days) {
                return this.countDownObj.days;
            }
            return 0;
        },
        timeRange() {
            let start, end;
            if (this.coupon.couponStartTime) start = new Date(this.coupon.couponStartTime.replace(/-/g, '/'));
            if (this.coupon.couponEndTime) end = new Date(this.coupon.couponEndTime.replace(/-/g, '/'));
            if (!isValidDate(start) || !isValidDate(end)) {
                return '-';
            }
            return (
                `${start.getFullYear()}.${start.getMonth() + 1}.${start.getDate()}` +
                '-' +
                `${end.getFullYear()}.${end.getMonth() + 1}.${end.getDate()}`
            );
        },
        expiresSoon() {
            const { couponEndTime, status } = this.coupon;
            if (!couponEndTime || status !== 2 || !this.showExpiresSoon) return false; // 未使用状态，才会即将过期
            const endDate = new Date(couponEndTime.replace(/-/g, '/'));
            const now = new Date();
            return endDate.getTime() - now.getTime() < 12 * 60 * 60 * 1000; // 距离结束时间12小时标记为即将过期
        },
        statusIconClass() {
            const prefix = 'status-';
            if (this.coupon.status == usedStatus) {
                return `${prefix}used`;
            }
            // 倒计时结束或后台返回已结束 变成过期样式
            if (this.coupon.status == timeoutStatus || this.isSellout) {
                return `${prefix}timeout`;
            }
            if (this.coupon.status == 2) {
                return this.showReceiveIcon ? `${prefix}receive` : '';
            }
            if (this.coupon.status == emptyStatus) {
                return `${prefix}empty`;
            }
            return '';
        },
        showToUseBtn() {
            return (
                this.active === true &&
                this.useMethod === 'click' &&
                this.showGotoUseBtn &&
                this.coupon.status == receiveStatus
            );
        },
        showContinueBtn() {
            return this.active === true && this.useMethod === 'click' && this.coupon.status == continueReceiveStatus;
        },
        showReceiveBtn() {
            return this.active === true && this.useMethod === 'click' && this.coupon.status == canReceiveStatus;
        },
        showCheckBtn() {
            return this.active === true && this.useMethod === 'check' && this.isShowCheck;
        },
        receiveBtnText() {
            return this.coupon.status == continueReceiveStatus ? '继续领取' : '立即领取';
        },
        couponType() {
            const couponType = this.coupon.couponType;
            if (couponType === 'DOUBLE_CARD') {
                return '翻倍卡';
            }
            if (couponType === 'RE_CASH_CARD') {
                return '返现卡';
            }
            return couponTarget[this.coupon.couponTarget];
        },
        isDoubleCard() {
            return this.coupon.couponType === 'DOUBLE_CARD';
        },
        isCashBackCard() {
            return this.coupon.couponType == 'RE_CASH_CARD';
        },
    },
    methods: {
        resetTimeDown() {
            // 倒计时数据
            this.countdownData.liveEndTime = this.coupon.couponEndTime
                ? new Date(this.coupon.couponEndTime.replace(/-/g, '/')).getTime()
                : 0;
            this.countdownData.serverTime = new Date().getTime();
            this.initTimeDown();
        },
        expand() {
            this.clickCouponPoint('coupon_detail');
            this.isExpand = !this.isExpand;
        },
        clickHandle() {
            this.$emit('click');
        },
        clickCouponPoint(obj_id) {
            const coupon = this.coupon;
            window.bigTj?.track('click', {
                obj_id,
                obj_type: 'my_couponlist',
                coupon_name: coupon.couponName,
                coupon_id: coupon.couponId,
                item_type: this.tabLabel,
            });
        },
        // 新增点击“去使用”埋点
        clickUseBtn() {
            this.emitItemClick('use_coupon');
        },
        // 分发点击事件
        emitItemClick(obj_id) {
            this.$emit('beforeClick', this.coupon);
            this.clickCouponPoint(obj_id);
            const coupon = this.coupon;
            if (this.business === 'recharge') {
                if (coupon && coupon.isFake == true) {
                    //假券不可点击
                    this.handleGoldSigning('coupon');
                    this.clickHandle();
                }
            }

            const def1 =
                coupon.couponType == 'RE_CASH_CARD' &&
                (coupon.couponTarget == 'QSC_PERIPHERY' || coupon.couponTarget == 'QSC_MOVIE');
            // const def2 = env.isIos && coupon.couponType == 'REDUCTION_COUPON' && coupon.couponTarget == 'QSC_RECHARGE';
            if (env.isMainMiniProgram && def1) {
                this.$toast('请到APP去使用');
                return;
            }
            if (this.showToUseBtn) {
                this.gotoUse();
            } else if (this.showReceiveBtn || this.showContinueBtn) {
                this.receive();
            } else if (this.showCheckBtn) {
                this.clickHandle();
            } else {
                console.log('do nothing');
            }
        },

        receive() {
            // 判断是否登录
            if (!loginState()) {
                this.$emit('showloginwall');
                return;
            }
            const coupon = this.coupon;
            if (coupon.status != receiveStatus) {
                if (coupon.receiveStatus === false) {
                    this.$toast(coupon.receiveMsg || '已领取');
                    return;
                }
                const couponType = {
                    QSSC_GOODS: undefined, //默认情况
                    QSC_TICKET: 'ticket',
                    QSC_RECHARGE: 'recharge',
                };

                receiceCoupon({
                    couponId: coupon.couponId,
                    type: couponType[coupon.couponTarget],
                })
                    .then(res => {
                        if (res.code == 200) {
                            if (res.data) {
                                if (res.data.flag == true) {
                                    console.error('jwepjwe---------ifjoweijfoweijfowie');
                                    this.$toast({
                                        message: `已为你成功领取${coupon.couponInfo || ''}优惠券`,
                                        iconClass: 'icon icon-success',
                                    });
                                    setReceiveCouponCache(coupon.couponId, this.receiveCacheTime);
                                } else {
                                    if (res.data.used) {
                                        // 改变为立即使用状态 status = 2 (已经领取过但是没有对应的缓存，所以要加入缓存并且修改按钮样式)
                                        setReceiveCouponCache(coupon.couponId, this.receiveCacheTime);
                                    }
                                    // 被领取完
                                    // status表示领取领取优惠券状态 而不是优惠券状态 注意和coupon.status不是同一个status
                                    // 记录缓存5分钟
                                    if (res.data.status != null && res.data.status == 2) {
                                        receiveEmptyResult(coupon.couponId);
                                    }
                                    // 每人最多领取n张 当做已领取处理
                                    // if (res.data.status != null && res.data.status == 4) {
                                    //     setReceiveCouponCache(this.coupon.couponId);
                                    // }
                                    this.$toast(res.data.msg);
                                }
                                this.$emit('onReceive', res.data);
                            } else {
                                this.$toast(res.msg);
                                // todo: 失败toast逻辑检查
                                // if (res.data && res.data.msg) {
                                //     this.$toast(res.data.msg);
                                // } else {
                                //     this.$toast('网络错误，请刷新重试');
                                // }
                            }
                        } else {
                            this.$emit('onReceive', res.msg);
                            this.$toast(res.msg);
                        }
                    })
                    .catch(e => {
                        console.log('e:', e);
                        this.$emit('onReceive', e);
                        this.$toast('网络错误，请刷新重试');
                    });
            }
            this.clickHandle();
        },

        gotoUse() {
            if (this.customGotoUse) {
                this.$emit('gotoUse');
                return;
            }
            if (this.coupon.linkUrl) {
                // 跳接口返回的地址
                this.jumpUrl(this.coupon.linkUrl);
            } else if (this.isDoubleCard) {
                // 翻倍卡跳首页
                this.jumpUrl('home');
            } else if (this.isCashBackCard) {
                this.jumpUrl('privilege');
            } else {
                // 无配置地址则跳凑单页面
                window.location.href =
                    '/new/coupon/getGoods/getGoods.html?ZZCAppArg=topbar_remove&id=' +
                    this.coupon.couponId +
                    '&couponName=' +
                    encodeURIComponent(this.coupon.couponInfo);
            }
        },
        jumpUrl(link) {
            const urlObj = urlObjs.find(e => e.route == link);
            if (urlObj) {
                if (env.isApp) {
                    // app 提审处理
                    if (window.appIsTiShen == 1) {
                        window.ZZCFL.Utils.nativeTabSwitch('shop');
                        return;
                    }
                    window.ZZCFL.Utils.nativeTabSwitch(urlObj.nativeTab);
                } else if (env.isMainMiniProgram) {
                    // 骑士卡小程序
                    window.wx.miniProgram.reLaunch({
                        url: urlObj.miniPath,
                    });
                } else {
                    window.location.href = urlObj.link;
                }
            } else {
                window.location.href = link;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.icon {
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
    display: inline-block;
}
.coupon-item-wrapper {
    margin: 0 auto 0.2rem;
    box-sizing: border-box;
    width: 7.12rem;
    .coupon-item-main {
        background-image: url(../images/couponItem/coupon_bg_normal.png);
        background-size: 100% 100%;
        background-position: 0 0;
        background-repeat: no-repeat;
        width: 100%;
        height: 1.9rem;
        display: flex;
        justify-content: flex-start;
        align-items: center;

        .item-left {
            overflow: hidden;
            height: 100%;
            flex: 0 0 2.01rem;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            position: relative;
            .price-wrapper {
                display: flex;
                justify-content: center;
                align-items: flex-end;
                .symbol {
                    opacity: 0.5;
                    font-size: 0.3rem;
                    line-height: 0.4rem;
                    color: #333;
                    letter-spacing: -0.05rem;
                }
                .price {
                    font-family: Helvetica Neue, Helvetica, -apple-system, PingFang SC, arial, sans-serif;
                    font-size: 0.6rem;
                    line-height: 0.6rem;
                    color: #333;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    max-width: 2.1rem;
                    opacity: 0.5;
                    font-weight: bold;
                }
            }
            .cash-back-wrapper {
                .text {
                    font-size: 0.7rem;
                    color: #333;
                    font-weight: 500;
                    opacity: 0.5;
                }
            }
            .rate-wrapper {
                display: flex;
                justify-content: center;
                align-items: flex-end;

                .x {
                    font-size: 0.32rem;
                    line-height: 0.4rem;
                    opacity: 0.5;
                }

                .rate {
                    font-size: 0.6rem;
                    font-weight: bold;
                    font-family: Helvetica Neue, Helvetica, -apple-system, PingFang SC, arial, sans-serif;
                    opacity: 0.5;
                    line-height: 0.6rem;
                    margin: 0 0.02rem;
                }

                .text {
                    font-size: 0.32rem;
                    line-height: 0.42rem;
                }
            }
            .price-desc {
                font-size: 0.22rem;
                color: #333;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
                overflow: hidden;
                max-width: 3rem;
                text-align: center;
                opacity: 0.5;
                max-height: 1rem;
            }
            .expires-soon {
                $fs: 0.18rem;
                color: #f7e7ba;
                background: #000;
                width: 2rem;
                text-align: center;
                position: absolute;
                font-size: $fs;
                line-height: $fs * 1.5;
                top: 0.3rem;
                left: 0.3rem;
                transform: rotateZ(-45deg);
                margin-left: -50%;
                margin-top: -$fs * 1.5 / 2;
                span {
                    font-family: FZLTHJW--GB1-0, fantasy;
                }
            }
        }
        .item-right {
            flex: 0 0 5.11rem;
            height: 100%;
            display: flex;
            justify-content: flex-start;
            align-items: flex-start;
            .text-wrapper {
                position: relative;
                width: 5.09rem;
                height: 100%;
                overflow: hidden;
                flex-direction: column;
                display: flex;
                align-items: flex-start;
                justify-content: center;
                .text-wrapper-top {
                    position: relative;
                    padding: 0.27rem 0.2rem 0.2rem;
                    width: 100%;
                    display: flex;
                    justify-content: center;
                    align-items: flex-start;
                    flex-direction: column;
                    box-sizing: border-box;
                    .coupon-name {
                        display: block;
                        position: relative;
                        z-index: 1;
                        max-width: 100%;
                        font-size: 0.24rem;
                        line-height: 0.3rem;
                        color: #333333;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        .name {
                            color: #999;
                        }
                        .gold-ico {
                            width: 1.1rem;
                            height: 0.3rem;
                            margin-right: 0.08rem;
                            vertical-align: bottom;
                        }
                        .tag {
                            color: #999;
                            background: #efefef;
                            border-radius: 0.06rem;
                            line-height: 0.3rem;
                            font-size: 0.2rem;
                            padding: 0 0.05rem;
                            display: inline-block;
                            margin-right: 0.08rem;
                        }
                    }
                    .middle-wrapper {
                        display: flex;
                        align-items: center;
                        width: 100%;
                        justify-content: space-between;
                        margin-top: 0.14rem;
                    }
                    .text-middle-wrapper {
                        position: relative;
                        width: 3.01rem;
                        .date {
                            font-weight: 300;
                            display: block;
                            font-size: 0.22rem;
                            opacity: 0.5;
                            color: #333333;
                        }
                        &.countdown {
                            font-size: 0.22rem;
                            opacity: 1;
                            color: #f15353;
                            font-weight: bold;
                        }
                    }
                    .btn {
                        font-size: 0.24rem;
                        width: 1.4rem;
                        height: 0.5rem;
                        border: 1px solid;
                        border-radius: 1rem;
                        box-sizing: border-box;
                        text-align: center;
                        line-height: 0.47rem;
                        &.btn-use {
                            border-color: #ddc47d;
                            color: #cfac4a;
                        }
                        &.btn-get {
                            border-color: #ddc47d;
                            background: #ddc47d;
                            color: #fff;
                            &.btn-continue {
                                border-color: #ddc47d;
                                background: #fff;
                                color: #cfac4a;
                            }
                        }
                    }
                    .checkbox {
                        right: 0.3rem;
                        top: 50%;
                        transform: translateY(-50%);
                        position: absolute;
                        z-index: 2;
                        .icon {
                            width: 0.36rem;
                            height: 0.36rem;
                            &.icon-checked {
                                background-image: url(../images/couponItem/icon_checked.png);
                            }
                            &.icon-unchecked {
                                background-image: url(../images/couponItem/icon_unchecked.png);
                            }
                        }
                    }
                }
                .desc-wrapper {
                    position: relative;
                    z-index: 1;
                    padding: 0 0.2rem;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    height: 0.5rem;
                    width: 100%;
                    box-sizing: border-box;
                    transform: translateY(0.07rem);
                    span {
                        font-size: 0.22rem;
                        color: #333;
                    }
                    .icon-arrow {
                        transition: all 0.3s;
                        width: 0.4rem;
                        height: 0.4rem;
                        background-image: url(../images/couponItem/icon_arrow.png);
                        transform: rotate(-180deg);
                        &.active {
                            transform: rotate(0deg);
                        }
                    }
                }
                .icon-status {
                    width: 1rem;
                    height: 1rem;
                    position: absolute;
                    right: -0.05rem;
                    top: -0.29rem;
                    display: none;
                    &[class*='status-'] {
                        display: block;
                    }
                    &.status-receive {
                        background-image: url(../images/couponItem/icon_get.png);
                    }
                    &.status-empty {
                        background-image: url(../images/couponItem/icon_empty.png);
                    }
                    &.status-used {
                        background-image: url(../images/couponItem/icon_used.png);
                    }
                    &.status-timeout {
                        background-image: url(../images/couponItem/icon_timeout.png);
                    }
                }
            }
        }
    }
    .coupon-desc {
        transition: all 0.3s;
        display: none;
        background-color: #f6f6f6;
        box-sizing: border-box;
        padding: 0.1rem 0.21rem;
        font-size: 0.22rem;
        color: #666666;
        border: 0.01rem solid #efefef;
        border-radius: 0 0 0.1rem 0.1rem;
        border-top: none !important;
        color: #333;
        * {
            color: #333;
        }
    }
    &.active {
        .item-right .text-wrapper .text-wrapper-top .coupon-name {
            .tag {
                color: #936022;
                background: #f7e7ba;
            }
            .name {
                color: #333;
            }
        }
        .coupon-item-main {
            opacity: 1;
            background-image: url(../images/couponItem/coupon_bg_active.png);
            .item-left {
                .price-wrapper {
                    .symbol {
                        opacity: 1;
                        color: #936022;
                    }
                    .price {
                        opacity: 1;

                        color: #936022;
                    }
                }
                .rate-wrapper {
                    .x {
                        opacity: 1;
                    }
                    .rate {
                        opacity: 1;
                    }
                    .text {
                        opacity: 1;
                    }
                }
                .cash-back-wrapper {
                    .text {
                        font-size: 0.7rem;
                        color: #936022;
                        font-weight: 500;
                        opacity: 1;
                    }
                }
                .price-desc {
                    opacity: 1;
                    color: #936022;
                }
            }
            .item-right {
                .text-wrapper .text-wrapper-top {
                    .coupon-name {
                        opacity: 1;
                    }
                    .text-middle-wrapper {
                        .date {
                            font-weight: 300;
                            opacity: 1;
                        }
                    }
                }
                .desc-wrapper {
                    span {
                        color: #666;
                    }
                }
            }
        }
        .coupon-desc {
            background-color: #fffbf4;
            border: 0.01rem solid #f7e7ba;
            color: #666;
            opacity: 1;
            * {
                color: #666;
            }
        }
    }
    &.expand {
        .coupon-item-main {
            background-image: url(../images/couponItem/coupon_bg_normal_expand.png);
        }
        &.active {
            .coupon-item-main {
                background-image: url(../images/couponItem/coupon_bg_active_expand.png);
            }
        }
        .coupon-desc {
            display: block;
        }
    }
    &.type-QSC_RECHARGE {
        &.active {
            .coupon-desc {
                background-color: #f4faff;
                border-color: #cfe6fa;
            }
            .coupon-item-main {
                background-image: url(../images/couponItem/coupon_bg_recharge.png);
                .item-left {
                    .price-wrapper {
                        .symbol {
                            color: #3c5e8c;
                        }
                        .price {
                            color: #3c5e8c;
                        }
                    }
                    .price-desc {
                        color: #3c5e8c;
                    }
                }
                .item-right .text-wrapper .text-wrapper-top .coupon-name .tag {
                    color: #3c5e8c;
                    background: #cfe6fa;
                }
                .item-right .text-wrapper .text-wrapper-top .btn {
                    &.btn-use {
                        border-color: #93b2dc;
                        color: #7297ca;
                    }
                    &.btn-get {
                        border-color: #93b2dc;
                        background: #93b2dc;
                        color: #fff;
                        &.btn-continue {
                            border-color: #93b2dc;
                            background: #fff;
                            color: #7297ca;
                        }
                    }
                }
            }
            &.expand {
                &.active {
                    .coupon-item-main {
                        background-image: url(../images/couponItem/coupon_bg_recharge_expand.png);
                    }
                }
            }
        }
    }
    &.type-QSC_TICKET {
        &.active {
            .coupon-desc {
                background-color: #fff8f4;
                border-color: #ffd5b7;
            }
            .coupon-item-main {
                background-image: url(../images/couponItem/coupon_bg_food.png);
                .item-left {
                    .price-wrapper {
                        .symbol {
                            color: #9e532c;
                        }
                        .price {
                            color: #9e532c;
                        }
                    }
                    .price-desc {
                        color: #9e532c;
                    }
                }
                .item-right .text-wrapper .text-wrapper-top .coupon-name .tag {
                    color: #9e532c;
                    background: #fddbc2;
                }
                .item-right .text-wrapper .text-wrapper-top .btn {
                    &.btn-use {
                        border-color: #f7aa82;
                        color: #e99366;
                    }
                    &.btn-get {
                        border-color: #f7aa82;
                        background: #f7aa82;
                        color: #fff;
                        &.btn-continue {
                            border-color: #f7aa82;
                            background: #fff;
                            color: #e99366;
                        }
                    }
                }
            }
            &.expand {
                &.active {
                    .coupon-item-main {
                        background-image: url(../images/couponItem/coupon_bg_food_expand.png);
                    }
                }
            }
        }
    }

    &.type-DOUBLE-CARD {
        &.active {
            .coupon-desc {
                background-color: #fff6f3;
                border-color: #ffd5b7;
            }

            .coupon-item-main {
                background-image: url(../images/couponItem/coupon_bg_double_card.png);
                .item-left {
                    .rate-wrapper {
                        .x,
                        .text {
                            color: #8c3621;
                        }
                        .rate {
                            color: #8c3621;
                        }
                    }
                    .price-desc {
                        color: #fff6f3;
                    }
                }

                .item-right .text-wrapper .text-wrapper-top .coupon-name .tag {
                    color: #8c3621;
                    background: #ffdede;
                }

                .item-right .text-wrapper .text-wrapper-top .btn {
                    &.btn-use {
                        border-color: #d88080;
                        color: #db6c6c;
                    }
                    &.btn-get {
                        border-color: #d88080;
                        background: #d88080;
                        color: #fff;
                        &.btn-continue {
                            border-color: #d88080;
                            background: #fff;
                            color: #db6c6c;
                        }
                    }
                }
            }
            &.expand {
                &.active {
                    .coupon-item-main {
                        background-image: url(../images/couponItem/coupon_bg_double_card_expand.png);
                    }
                }
            }
        }
    }
}
</style>

<style lang="scss">
.mint-toast.is-placemiddle {
    max-width: 6.3rem;
    border-radius: 0.16rem;
    .icon.icon-success {
        margin: 0 auto;
        width: 0.8rem;
        height: 0.8rem;
        background: url(./images/icon-success.png) no-repeat;
        background-size: 100% 100%;
    }
}
</style>
